import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Authority, User} from '../../../types/user';
import {Language} from '../language-switcher/types/language-switcher.types';
import {MatDialogRef} from '@angular/material/dialog';
import {HttpHandlingService} from '../../../../api/services/http-handling.service';
import {SERVER_API_URL} from '../../../types/app.constants';

@Component({
  selector: 'app-registration-dialog',
  templateUrl: './registration-dialog.component.html',
  styleUrls: ['./registration-dialog.component.css']
})
export class RegistrationDialogComponent implements AfterViewChecked {

  emailControl = new UntypedFormControl('', [Validators.required, Validators.email]);
  loginFieldControl = new UntypedFormControl('', Validators.required);
  passwordFieldControl = new UntypedFormControl('', Validators.required);
  password2FieldControl = new UntypedFormControl('', Validators.required);
  firstNameFieldControl = new UntypedFormControl('', Validators.required);
  lastNameFieldControl = new UntypedFormControl('', Validators.required);

  userEmail = '';
  login = '';
  password = '';
  password2 = '';
  firstName = '';
  lastName = '';

  hidePasswordField = true;
  hidePassword2Field = true;

  serverIsDown = false;

  constructor(private http: HttpClient, public dialogRef: MatDialogRef<RegistrationDialogComponent>, private cdr: ChangeDetectorRef,
              private httpHandlingService: HttpHandlingService) {}

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  /**
   * function which provides error messages in the process of logging in
   * @param fieldControl with information about desired field (login, password, ...)
   */
  getErrorMessage(fieldControl: UntypedFormControl): string {
    return this.httpHandlingService.handleUserErrorOutput(fieldControl);
  }

  /**
   * function for checking, if user is manipulating with one of the password inputs
   */
  onPasswordChangeCheck(): void {
    if (this.password !== '' && this.password2 !== '' && this.password !== this.password2) {
      this.passwordFieldControl.setErrors({passwordsdonotmatch: true});
      this.password2FieldControl.setErrors({passwordsdonotmatch: true});
    } else {
      this.passwordFieldControl.setErrors(null);
      this.password2FieldControl.setErrors(null);
    }
  }

  /**
   * function for register user to database
   */
  registrateUser(): void {
    const user = new User(null, this.userEmail, this.login, this.password, this.firstName, this.lastName, '', false, this.login,
      new Date(), this.login, new Date(), Language.EN, [Authority.USER]);
    const headers = { 'content-type': 'application/json'};
    this.http.post<any>(SERVER_API_URL + '/api/register', user, {headers}).subscribe(data => {
    }, (error: HttpErrorResponse) => { this.handleRegistrationHttpErrors(error); },
      () => this.dialogRef.close());
  }

  /**
   * function for evaluating, if all necessary fields are filled
   * this function disables button, if all data are not provided
   */
  allFieldsAreFilled(): boolean {
    return !(this.emailControl.valid && this.loginFieldControl.valid && this.passwordFieldControl.valid &&
      this.password2FieldControl.valid && this.firstNameFieldControl.valid && this.lastNameFieldControl.valid);
  }

  /**
   * function for handling HTTP errors in the process of registration
   */
  handleRegistrationHttpErrors(error: HttpErrorResponse): void {
    if (error.status !== 0) {
      if (error.error.errorKey) {
        switch (error.error.errorKey) {
          case 'userexists':
            this.loginFieldControl.setErrors({userexists: true});
            break;
          case 'emailexists':
            this.emailControl.setErrors({emailexists: true});
            break;
          default:
            alert('Unexpected problem! Notify administrator!');
            break;
        }
      } else {
        this.handleRegistrationFieldErrors(error.error.fieldErrors);
      }
      this.serverIsDown = false;
    } else {
      this.serverIsDown = true;
    }
  }

  /**
   * function for handling fields errors
   * @param fieldErrors for evaluation of fields with errors
   */
  handleRegistrationFieldErrors(fieldErrors: any[]): void {
    for (const fieldError of fieldErrors) {
      switch (fieldError.message) {
        case 'Pattern':
          this.getFieldControl(fieldError.field).setErrors({wrongloginpattern: true});
          break;
        case 'Size':
          this.getFieldControl(fieldError.field).setErrors({wrongloginpattern: true});
          if (fieldError.field === 'login' || fieldError.field === 'firstName' || fieldError.field === 'lastName') {
            this.getFieldControl(fieldError.field).setErrors({wrongsize50: true});
          } else if (fieldError.field === 'password') {
            this.getFieldControl(fieldError.field).setErrors({wrongsize60: true});
          } else if (fieldError.field === 'email') {
            this.getFieldControl(fieldError.field).setErrors({wrongsize254: true});
          }
          break;
      }
    }
  }

  /**
   * function for getting field controls by name
   * @param fieldName for evaluation of field names
   */
  getFieldControl(fieldName: string): UntypedFormControl {
    switch (fieldName) {
      case 'email': return this.emailControl;
      case 'login': return this.loginFieldControl;
      case 'password': return this.passwordFieldControl;
      case 'firstName': return this.firstNameFieldControl;
      case 'lastName': return this.lastNameFieldControl;
    }
  }
}
